import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enGB from "./locales/en-GB.json";
import enUS from "./locales/en-US.json";
import sv from "./locales/sv.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import it from "./locales/it.json";
import es from "./locales/es.json";

import {
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
  normalizeLanguage,
} from "./languages";

export {
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
  normalizeLanguage,
} from "./languages";
export type { SupportedLanguage } from "./languages";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "en-GB": { translation: enGB },
      "en-US": { translation: enUS },
      sv: { translation: sv },
      fr: { translation: fr },
      de: { translation: de },
      it: { translation: it },
      es: { translation: es },
    },
    fallbackLng: {
      en: ["en-US"],
      default: ["en-US"],
    },
    supportedLngs: [...SUPPORTED_LANGUAGES, "en"],
    nonExplicitSupportedLngs: false,
    load: "currentOnly",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Prefer an explicit user choice in localStorage; otherwise use the browser.
      // Do not auto-cache navigator results — only LanguageSelector writes boni_lang.
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: [],
      convertDetectedLanguage: normalizeLanguage,
    },
  });

const syncDocumentLang = (language: string) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = normalizeLanguage(language);
  }
};

syncDocumentLang(i18n.language);
i18n.on("languageChanged", syncDocumentLang);

export default i18n;
